import { FC } from 'react';

import cn from 'classnames';
import { Checkbox } from 'ui/components/form';
import { Button } from 'ui/components/common';
import c from 'utils/constants';
import { useAdmin } from 'utils/helpers';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import { useUpdateAdminNotificationsStatus } from 'modules/admin/notifications/hooks';

import { useUpdateNotificationsStatus } from '../hooks';

type PROPS = {
  tabSelected: string;
  itemsSelected: Array<{
    _id: string;
    type: string;
    source: string;
    referenceId: string;
    userId: string;
    status: string;
    createdAt: string;
  }>;
  handleCancel: () => void;
  handleBulkSelect: () => void;
  notificationsCount: number;
};

const NotificationTabActions: FC<PROPS> = ({
  tabSelected,
  itemsSelected = [],
  handleCancel = () => null,
  handleBulkSelect = () => null,
  notificationsCount,
}) => {
  const { isAdmin } = useAdmin();
  const {
    state: { isPreview },
  } = useAppWrapperContext();

  const { mutate: updateNotificationStatus } = (
    isAdmin && !isPreview
      ? useUpdateAdminNotificationsStatus
      : useUpdateNotificationsStatus
  )();

  const { READ, UNREAD } = c.NOTIFICATION_STATUSES;
  const notificationIds = itemsSelected?.map?.((item) => item._id);

  const markSelectedWithStatus = (status: string) => {
    updateNotificationStatus(
      { status, notificationIds },
      { onSuccess: handleCancel },
    );
  };

  return (
    <div
      className={cn(
        !itemsSelected.length ? 'hidden' : '',
        'border-b-[0.5px]',
        'border-b-[#E4EDF0]',
        'bg-fill-tertiary',
        'px-[15px]',
      )}
    >
      <div
        className={cn(
          'flex',
          'items-center',
          'justify-between',
          'pt-[10px]',
          'font-normal',
        )}
      >
        <div className="flex items-center gap-[10px] my-[3px]">
          <Checkbox
            defaultChecked={notificationsCount === itemsSelected.length}
            onChange={handleBulkSelect}
          />
          <div>{itemsSelected.length} selected</div>
        </div>
        <Button
          className="text-sm font-bold"
          onClick={handleCancel}
          intent="text"
          label="Cancel"
        />
      </div>
      <div className={cn('flex', 'gap-[11px]', 'pt-[10px] pb-[14px]')}>
        {(tabSelected === READ || tabSelected === 'all') && (
          <Button
            intent={'link'}
            className="text-secondary-light"
            onClick={() => markSelectedWithStatus(UNREAD)}
            label="MARK AS UNREAD"
          />
        )}
        {(tabSelected === UNREAD || tabSelected === 'all') && (
          <Button
            intent={'link'}
            className="text-secondary-light"
            onClick={() => markSelectedWithStatus(READ)}
            label="MARK AS READ"
          />
        )}
      </div>
    </div>
  );
};

export default NotificationTabActions;
